import { headlessUserClaims } from 'interfaces/user';
import { useEffect } from 'react';
import useUser, { getUserFromParsedIdToken } from 'hooks/useUser';
import { isHeadless } from 'utils/headless';

const useHeadlessUser = () => {
  const { user, setUser, isInitialised } = useUser();

  // Firebase restores a signed-in session asynchronously, so the robot user waits for it.
  useEffect(() => {
    if (isHeadless() && isInitialised && !user) {
      setUser(getUserFromParsedIdToken({ claims: headlessUserClaims }));
    }
  }, [user, setUser, isInitialised]);
};

export default useHeadlessUser;
